import { getBalanceActivities, getBalance, depositBalance } from "../../api/site";
import { log2 } from "../../utils/log2";

const log = log2("wallet.vuex");
const wallet = {
    namespaced: true,
    state: {
        wallet: {},
        activities: [],
        totalActivity: 0,
    },
    mutations: {
        SET_BALANCE: (state, payload) => {
            state.wallet = payload;
        },
        SET_BALANCE_ACTIVITY: (state, payload) => {
            state.activities = payload;
        },
        SET_TOTAL_ACTIVITY: (state, payload) => {
            state.totalActivity = payload;
        },
    },
    actions: {
        getBalance({ commit }) {
            getBalance().then((balance) => {
                const mapBalance = balance.reduce((acc, wallet) => {
                    acc[wallet.type] = wallet;
                    return acc;
                }, {});
                commit("SET_BALANCE", mapBalance);
            });
        },
        getWalletLogs({ commit }, { page = 1, perPage = 20, type = null }) {
            getBalanceActivities(page, perPage, type).then((data) => {
                commit("SET_BALANCE_ACTIVITY", data.activities);
                commit("SET_TOTAL_ACTIVITY", data.total);
            });
        },
        addBalance({ commit, state }, payload) {
            depositBalance(payload).then((balance) => {
                commit("SET_BALANCE", {
                    ...state.wallet,
                    [balance.type]: balance,
                });
            });
        },
    },
};

export default wallet;
